import React, { ReactNode } from 'react';
import { Flex, Skeleton } from 'antd';

import Styled from './styled';
const { Container, Content, Title, TitleContainer, Subtitle, LearnMoreLink } = Styled;

interface Props {
  children: ReactNode;
  title?: string;
  subtitle?: string;
  learnMoreLink?: string;
  loading?: boolean;
  containerStyle?: React.CSSProperties;
  extra?: ReactNode;
  id?: string;
}

const Card: React.FC<Props> = (props: Props) => {
  const { children, extra } = props;
  return (
    <Container id={props.id} style={props.containerStyle}>
      {props.title && (
        <TitleContainer>
          <Flex justify="space-between" align="center">
            <Title>{props.title}</Title>
            {extra}
          </Flex>
          {props.subtitle && (
            <Subtitle>
              {props.subtitle}{' '}
              {props.learnMoreLink ? (
                <LearnMoreLink href={props.learnMoreLink} target="_blank">
                  Learn more
                </LearnMoreLink>
              ) : (
                ''
              )}
            </Subtitle>
          )}
        </TitleContainer>
      )}
      <Content>{props.loading ? <Skeleton active /> : children}</Content>
    </Container>
  );
};

export default Card;
